// @ts-nocheck
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import {
  BRAND,
  SHIELD_VIEWBOX,
  SHIELD_BODY,
  SHIELD_FACET,
  SHIELD_INNER,
  SHIELD_W,
  WORDMARK_WE,
  WORDMARK_SAFE,
  WORDMARK_WIDTH,
} from './brandAssets';

Logo.propTypes = {
  sx: PropTypes.object,
  showText: PropTypes.bool
};

const LOCKUP_W = Math.ceil(76 + WORDMARK_WIDTH); // shield + gap + wordmark
const LOCKUP_H = 76;

export function ShieldMark({ size = 40, strokeWidth = 6 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox={SHIELD_VIEWBOX}
      preserveAspectRatio="xMidYMid meet"
      style={{ display: 'block', maxWidth: size, maxHeight: size }}
    >
      <path d={SHIELD_BODY} fill={BRAND.amber} />
      <path d={SHIELD_FACET} fill={BRAND.amberDeep} />
      <path d={SHIELD_INNER} fill="none" stroke="#FFFFFF" strokeOpacity=".28" strokeWidth="1.3" />
      <path
        d={SHIELD_W}
        fill="none"
        stroke="#FFFFFF"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function Logo({ sx, showText = true }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const ink = isDark ? '#FFFFFF' : BRAND.ink;

  const rawH = sx?.height;
  const rawW = sx?.width;
  const baseSize = typeof rawH === 'number' ? rawH : typeof rawW === 'number' ? rawW : 40;

  if (!showText) {
    return (
      <Box
        sx={{
          width: baseSize,
          height: baseSize,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          ...sx
        }}
      >
        <ShieldMark size={baseSize} strokeWidth={baseSize < 28 ? 7.5 : 6} />
      </Box>
    );
  }

  const { width: _w, height: _h, ...containerSx } = sx || {};

  return (
    <Box sx={{ display: 'inline-flex', ...containerSx }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height={baseSize}
        width={(baseSize * LOCKUP_W) / LOCKUP_H}
        viewBox={`0 0 ${LOCKUP_W} ${LOCKUP_H}`}
        style={{ display: 'block' }}
      >
        <svg x="0" y="6" width="57" height="64" viewBox={SHIELD_VIEWBOX}>
          <path d={SHIELD_BODY} fill={BRAND.amber} />
          <path d={SHIELD_FACET} fill={BRAND.amberDeep} />
          <path d={SHIELD_INNER} fill="none" stroke="#FFFFFF" strokeOpacity=".28" strokeWidth="1.3" />
          <path
            d={SHIELD_W}
            fill="none"
            stroke="#FFFFFF"
            strokeWidth="6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <g transform="translate(76 50)">
          <path d={WORDMARK_WE} fill={ink} fillOpacity={isDark ? 0.92 : 1} />
          <path d={WORDMARK_SAFE} fill={ink} />
        </g>
      </svg>
    </Box>
  );
}
